import client from "graphql/client";
import i18next from "i18next";
import { loader } from "graphql.macro";
import { BOOK_LOADED } from "redux/types";
import { snackbarSuccess, snackbarError } from "shared/redux/actions/Snackbar";
import createBookFromData from "helpers/createBookFromData";
import bookFlowItemAdd from "redux/actions/books/bookFlowItemAdd";

const editBookMutation = loader("graphql/mutations/books/editBook.graphql");

export function bookSetDefaultContent(osbn, startItem, defaultChapters, isInitalChapter = false) {
    return async (dispatch, getState) => {
        const { current: organisation } = getState().organisation;
        try {
            const { data } = await client.mutate({
                mutation: editBookMutation,
                variables: {
                    organisationId: organisation.id,
                    osbn,
                    startItem,
                    defaultChapters
                },
            });

            const { editBook } = data;
            const book = createBookFromData(editBook);

            dispatch({
                type: BOOK_LOADED,
                id: osbn,
                book: book
            });

            dispatch(snackbarSuccess(i18next.t("books.edit.success")));

            if (isInitalChapter) {
                const flowItem = {
                    label: 'Introduction',
                    result: 'END',
                    description: 'Your introduction',
                    isIntroduction: true,
                    type: 'textInfo'
                };
                dispatch(bookFlowItemAdd(osbn, startItem, flowItem));
            }

        } catch (error) {
            console.error(error);
            dispatch(snackbarError(i18next.t("books.edit.failed")));
        }
    };
}